import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'alreadyAddedValues' })
export class AlreadyAddedValuesPipe implements PipeTransform {
	// refreshFilter is here only for angular to detect changes, so we don't have to set pure: false and slow down the app
	transform(allValues: any[], alreadySelected: any[], refreshFilter: boolean, selectedAs?: string): any[] {
		if (!allValues) {
			return [];
		}
		if (!alreadySelected) {
			return allValues;
		}

		return allValues.filter(item => {
			if (!selectedAs) {
				return !(alreadySelected.indexOf(item) >= 0);
			}

			if (alreadySelected.some(i => i === item[selectedAs])) {
				return false;
			}
			return true;
		});
	}
}
